<template>
    <div class="chart-module-header">
        <div class="title">
            <div class="title-row">
                <div class="false-button grid-drag-handle" v-if="!props.blockedActions?.changeLayout" data-module-move-icon>
                    <font-awesome-icon
                        class="icon"
                        :icon="['fas', 'up-down-left-right']"
                    />
                </div>
                <span v-if="props.title">{{ props.title }}</span>
            </div>
            <button
                v-if="isMobileView && props.showOptionsButton"
                type="button"
                class="false-button module-options-trigger"
                aria-label="Module options"
                @click.stop="emit('click:options', $event)"
            >
                <font-awesome-icon class="icon" :icon="['fas', 'sliders']" />
            </button>
        </div>
        <div class="centre">
            <slot name="centre" />
        </div>
        <div class="right">
            <slot name="right" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { IModuleBlockedActions } from '@/interfaces/actions/enact/IModuleActions.ts';
import { useUIStore } from '@/stores/uiStore.ts';
import { storeToRefs } from 'pinia';

const props = defineProps<{
    title?: string;
    blockedActions?: IModuleBlockedActions;
    showOptionsButton?: boolean;
}>();

const emit = defineEmits<{
    'click:options': [Event];
}>();

const uiStore = useUIStore();
const { isMobileView } = storeToRefs(uiStore);

</script>

<style lang="scss" scoped>
.chart-module-header {
    display: grid;
    grid-template-columns: auto minmax(min-content, 1fr) max-content;
    gap: var(--defaultSpacing);
    padding: var(--smallSpacing) var(--defaultSpacing);
}

.title {
    font-size: var(--defaultFontSize);
    text-wrap: wrap;
    font-weight: var(--boldFontWeight);
    color: var(--primaryFont);
    text-overflow: ellipsis;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--smallSpacing);

    @include responsive(md) {
        font-size: var(--defaultFontSize);
        flex-direction: row;
    }

    .grid-drag-handle{
        cursor: move;
        color: var(--actionColour);
        width: 0;
        opacity: 0;
        transition: all 0.4s ease-in-out;
    }
}

.title-row {
    display: flex;
    align-items: center;
    gap: var(--defaultSpacing);
    min-width: 0;
}

.centre, .right {
    display: flex;
    gap: var(--defaultSpacing);
    align-items: center;
    min-width: 0;
}

.centre {
    min-width: min-content;
}

.module-options-trigger {
    color: var(--primaryFont);
    padding: var(--extraSmallSpacing) var(--smallSpacing);
    border: solid 1px var(--neutral300);
    border-radius: var(--borderRadiusOuter);
    background: var(--neutral0);
    display: inline-flex;
    align-items: center;
    gap: var(--smallSpacing);
}
</style>
